import React from "react";
import { ImageInput } from "../..";
import { decideIfFullWidthOrFullHeightImg } from "../../comps/ImageEditor/utils/decideIfFullWidthOrFullHeightImg";
import { StyledAbsPosShellImageEditor } from "./styled";

export const ImageDisplayInMask = ({
  maskAspectRatio,
  aspectRatio, //this is the aspectRatio prop that is passed to ImageInput
  ...imageInputProps
}) => {
  /**
   * now this is a complex one:
   * our image renderer renders the image at a certain aspect ratio
   * our thumbnail has a fixed aspect ratio of itself that is '1/1'
   * This means that, if the imageeditor is more vertical, it needs to take full width within the thumbnail
   * and full height if it is more horizontal.
   * Basically what happens inside the imageEditor, needs to repeat itself over here..
   *
   */

  let rendererStretch = decideIfFullWidthOrFullHeightImg({
    imgWidth: parseInt(aspectRatio.split("/")[0]),
    imgHeight: parseInt(aspectRatio.split("/")[1]),
    wrapperAspectRatio: maskAspectRatio,
  });

  return (
    <StyledAbsPosShellImageEditor {...{ rendererStretch }}>
      <ImageInput
        {...imageInputProps}
        aspectRatio={aspectRatio}
        stretchToFullHeight={rendererStretch === "fullHeight" && true}
        readOnly={true}
        enableCaptions={false}
      />
    </StyledAbsPosShellImageEditor>
  );
};
